/* BonTon — interazioni: menu, ricerca, carrello laterale, preferiti, varianti. */
(() => {
  'use strict';
  const R = window.BonTon.routes;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const T = window.BonTon.t || {};
  const money = cents => new Intl.NumberFormat(window.BonTon.locale || 'it', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  let toastTimer;

  function notify(text) {
    const t = $('#toast'); if (!t) return;
    clearTimeout(toastTimer); t.textContent = text; t.classList.add('show');
    toastTimer = setTimeout(() => t.classList.remove('show'), 2500);
  }
  function closeAll() { $$('dialog[open]').forEach(d => d.close()); }
  function openDialog(id) {
    const d = document.getElementById(id); if (!d) return;
    closeAll(); d.showModal();
    if (id === 'search-dialog') $('#search-input').focus();
  }

  /* Preferiti (salvati nel browser) */
  const KEY = 'bonton-saved';
  const readSaved = () => { try { const v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; } catch { return []; } };
  const writeSaved = v => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch {} };
  function paintSaved() {
    const saved = readSaved();
    $$('[data-action="save"]').forEach(b => b.setAttribute('aria-pressed', saved.includes(b.dataset.id)));
  }
  function toggleSaved(id) {
    let saved = readSaved(); const had = saved.includes(id);
    saved = had ? saved.filter(x => x !== id) : [...saved, id];
    writeSaved(saved); paintSaved();
    notify(had ? T.unsaved : T.saved);
  }

  /* Carrello */
  async function getCart() { const r = await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  function setCount(n) { const c = $('#cart-count'); if (c) { c.textContent = n; c.dataset.count = n; } }
  function renderCart(cart) {
    setCount(cart.item_count);
    $('#cart-title-count').textContent = '(' + cart.item_count + ')';
    const list = $('#cart-list'), summary = $('#cart-summary');
    if (!cart.items.length) {
      list.innerHTML = `<div class="empty-state"><h3>${T.cart_empty_t}</h3><p>${T.cart_empty_p}</p><a class="text-link" href="${R.root}collections/all">${T.browse}</a></div>`;
      summary.hidden = true; summary.innerHTML = ''; return;
    }
    list.innerHTML = cart.items.map((it, i) => {
      const opts = (it.options_with_values || []).filter(o => o.name !== 'Title').map(o => esc(o.value)).join(' · ');
      return `<div class="cart-row"><div class="cart-img">${it.image ? `<img src="${esc(it.image)}&width=300" alt="${esc(it.product_title)}" loading="lazy">` : ''}</div><div><h3><a href="${esc(it.url)}">${esc(it.product_title)}</a></h3><p>${T.pdf}${opts ? ' · ' + opts : ''}<br>${it.quantity > 1 ? it.quantity + ' ' + T.copies : T.copy1}</p><div class="row-bottom"><button class="small-link" type="button" data-action="remove-cart" data-line="${i + 1}">${T.remove}</button><span>${money(it.final_line_price)}</span></div></div></div>`;
    }).join('');
    summary.hidden = false;
    summary.innerHTML = `<div class="total"><span>${T.total}</span><span>${money(cart.total_price)}</span></div><p>${T.digital_note}</p><a class="solid" href="/checkout">${T.checkout}</a>`;
  }
  async function openCart() { openDialog('cart-dialog'); renderCart(await getCart()); }
  async function changeLine(line, quantity) {
    const r = await fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    renderCart(await r.json());
  }

  /* Varianti nella scheda prodotto */
  function initVariants() {
    const data = $('[data-bt-variants]'); if (!data) return;
    const variants = JSON.parse(data.textContent);
    const selects = $$('[data-bt-option]');
    const idInput = $('[data-bt-variant-id]'), btn = $('[data-bt-add]'), price = $('[data-bt-price]');
    selects.forEach(sel => sel.addEventListener('change', () => {
      const chosen = selects.map(s => s.value);
      const v = variants.find(v => v.options.every((o, i) => o === chosen[i]));
      if (!v) { btn.disabled = true; btn.textContent = T.unavailable; return; }
      idInput.value = v.id; btn.disabled = !v.available;
      btn.textContent = v.available ? T.add : T.unavailable;
      price.innerHTML = (v.compare_at_price > v.price ? `<span class="price-compare">${money(v.compare_at_price)}</span>` : '') + money(v.price);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }));
  }

  /* Ricerca predittiva */
  let searchTimer;
  async function search(q) {
    const status = $('#search-status'), box = $('#search-results');
    if (!q) { status.textContent = status.dataset.default || status.textContent; box.innerHTML = ''; return; }
    try {
      const r = await fetch(`${R.search}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`, { headers: { Accept: 'application/json' } });
      const d = await r.json(); const list = d.resources?.results?.products || [];
      status.dataset.default = status.dataset.default || status.textContent; status.textContent = list.length + ' ' + (list.length === 1 ? T.result : T.results);
      box.innerHTML = list.length ? list.map(p => `<a class="search-result" href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}&width=200" alt="${esc(p.title)}">` : '<span></span>'}<div><h3>${esc(p.title)}</h3><p>${money(Math.round(parseFloat(p.price) * 100))} · ${T.pdf}</p></div></a>`).join('')
        : `<div class="empty-state"><h3>${T.no_search}</h3><p>${T.search_hint}</p></div>`;
    } catch { status.textContent = T.press_enter; }
  }

  /* Eventi */
  document.addEventListener('click', e => {
    const close = e.target.closest('[data-close]'); if (close) { close.closest('dialog').close(); return; }
    const b = e.target.closest('[data-action]'); if (!b) return;
    const a = b.dataset.action;
    if (a === 'open-menu') {
      $('#mobile-nav').innerHTML = [...$('#main-nav').children].map(el => {
        if (el.classList.contains('has-sub')) {
          const top = el.querySelector('.bt-nav-top');
          const subs = $$('.bt-sub a', el).map(x => `<a class="sub" href="${x.getAttribute('href')}">${esc(x.querySelector('.bt-sub__name')?.textContent || x.textContent.trim())}${x.querySelector('small') ? ` <small>${esc(x.querySelector('small').textContent)}</small>` : ''}</a>`).join('');
          return `<p class="mobile-nav-group">${esc(top.textContent)}</p>${subs}`;
        }
        return `<a href="${el.getAttribute('href')}">${esc(el.textContent)}</a>`;
      }).join('');
      openDialog('menu-dialog');
    }
    else if (a === 'open-cart') { e.preventDefault(); openCart(); }
    else if (a === 'open-search') { openDialog('search-dialog'); }
    else if (a === 'save') { e.preventDefault(); toggleSaved(b.dataset.id); }
    else if (a === 'remove-cart') { changeLine(Number(b.dataset.line), 0); }
  });
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-bt-product-form]'); if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]'); btn.disabled = true;
    try {
      const r = await fetch(R.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!r.ok) { const err = await r.json(); notify(err.description || T.add_error); return; }
      await openCart();
    } finally { btn.disabled = false; }
  });
  document.addEventListener('input', e => {
    if (e.target.id === 'search-input') { clearTimeout(searchTimer); const q = e.target.value.trim(); searchTimer = setTimeout(() => search(q), 220); }
  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-bt-sort]')) { const url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); location.href = url; }
  });
  $$('dialog').forEach(d => d.addEventListener('click', e => {
    if (e.target !== d) return; const r = d.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
  }));
  // Header: bordo dopo lo scroll
  const header = $('.header-wrapper');
  const onScroll = () => { if (!header) return; header.style.borderBottomColor = scrollY > 10 ? 'var(--line)' : 'transparent'; header.classList.toggle('is-solid', scrollY > 40); };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* Lingua preferita: al primo accesso porta il visitatore nella lingua del suo browser.
     Se la lingua non è disponibile e non è l'italiano, usa l'inglese. La scelta manuale vince sempre. */
  function preferredLanguage() {
    const B = window.BonTon, langs = B.langs || [];
    if (langs.length < 2) return;
    let chosen = null;
    try { chosen = localStorage.getItem('bt-lang'); } catch {}
    if (chosen || /bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) return;
    const wanted = (navigator.languages || [navigator.language || '']).map(l => (l || '').slice(0, 2).toLowerCase());
    let target = wanted.find(l => langs.includes(l));
    if (!target) target = wanted[0] === B.primaryLocale ? B.primaryLocale : (langs.includes('en') ? 'en' : B.primaryLocale);
    try { localStorage.setItem('bt-lang', target); } catch {}
    if (target === B.locale) return;
    const current = B.locale === B.primaryLocale ? '' : '/' + B.locale;
    let path = location.pathname;
    if (current && path.startsWith(current)) path = path.slice(current.length) || '/';
    const prefix = target === B.primaryLocale ? '' : '/' + target;
    location.replace(prefix + path + location.search + location.hash);
  }
  document.addEventListener('submit', e => {
    const f = e.target; const code = e.submitter?.value || f.querySelector('[name=locale_code]')?.value;
    if (f.matches('form[action*="localization"]') && code) { try { localStorage.setItem('bt-lang', code); } catch {} }
  }, true);
  document.addEventListener('change', e => {
    if (e.target.id === 'bt-lang') { try { localStorage.setItem('bt-lang', e.target.value); } catch {} }
  }, true);

  /* Slideshow hero */
  function initSlides() {
    $$('[data-bt-slides]').forEach(root => {
      const slides = $$('.bt-slide', root), dots = $$('.bt-slides__dot', root);
      if (slides.length < 2) return;
      const ms = (parseInt(root.dataset.interval, 10) || 6) * 1000;
      root.style.setProperty('--bt-int', ms / 1000 + 's');
      const auto = root.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      let i = 0, timer;
      const go = n => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k !== i); });
        dots.forEach((d, k) => { d.classList.remove('is-active'); void d.offsetWidth; d.classList.toggle('is-active', k === i); });
        schedule();
      };
      const schedule = () => { clearTimeout(timer); if (auto && !root.classList.contains('is-paused')) timer = setTimeout(() => go(i + 1), ms); };
      dots.forEach(d => d.addEventListener('click', () => go(parseInt(d.dataset.btGoto, 10))));
      root.addEventListener('mouseenter', () => { root.classList.add('is-paused'); clearTimeout(timer); });
      root.addEventListener('mouseleave', () => { root.classList.remove('is-paused'); go(i); });
      let x0 = null;
      root.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
      document.addEventListener('visibilitychange', () => document.hidden ? clearTimeout(timer) : schedule());
      schedule();
    });
  }

  /* Comparsa morbida delle sezioni e delle foto allo scorrimento */
  function initReveal() {
    if (document.body.classList.contains('template-index')) $$('main > .shopify-section:not(:first-child)').forEach(s => s.setAttribute('data-bt-reveal', ''));
    const els = $$('[data-bt-reveal]'); if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach((e, i) => { e.style.transitionDelay = (e.classList.contains('gallery-item') ? (i % 2) * 120 : 0) + 'ms'; io.observe(e); });
    $$('video[autoplay]').forEach(v => { v.muted = true; v.play().catch(() => {}); });
  }
  /* Sottomenu Pattern: tastiera e touch */
  $$('.bt-nav-item.has-sub').forEach(item => {
    const top = item.querySelector('.bt-nav-top');
    const set = v => { item.classList.toggle('is-open', v); top.setAttribute('aria-expanded', v); };
    item.addEventListener('mouseenter', () => set(true)); item.addEventListener('mouseleave', () => set(false));
    item.addEventListener('focusin', () => set(true)); item.addEventListener('focusout', e => { if (!item.contains(e.relatedTarget)) set(false); });
    top.addEventListener('click', e => { if (matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) { e.preventDefault(); set(true); } });
    item.addEventListener('keydown', e => { if (e.key === 'Escape') { set(false); top.focus(); } });
  });
  preferredLanguage(); paintSaved(); initVariants(); initSlides(); initReveal();
})();
